<template>
  <div class="query-correction" role="heading" aria-level="2">
    <div v-if="correctedUrl" class="query-correction__corrected">
      {{ $t('web.queryCorrection.corrected') }}
      <ELink
        class="query-correction__link"
        color="result"
        :href="correctedUrl"
        rel="noopener"
        data-test-id="query-correction-corrected"
      >
        {{ corrected }}
      </ELink>
    </div>
    <div v-if="overrideUrl" class="query-correction__override">
      {{ $t('web.queryCorrection.original') }}
      <ELink
        class="query-correction__link"
        color="result"
        :href="overrideUrl"
        rel="noopener"
        data-test-id="query-correction-override"
      >
        {{ original }}
      </ELink>
    </div>
  </div>
</template>

<script>
import ELink from '~~/common/vue/components/link';

export default {
  name: 'EQueryCorrection',
  components: { ELink },
  props: {
    corrected: {
      type: String,
      required: true,
    },
    override: {
      type: String,
      required: true,
    },
    original: {
      type: String,
      required: true,
    },
  },
  computed: {
    correctedUrl() {
      return this.withQuery(this.corrected);
    },
    overrideUrl() {
      return this.withQuery(this.override);
    },
  },
  methods: {
    withQuery(q) {
      try {
        const query = { ...this.$route.query, q };
        const { href } = this.$router.resolve({ query });
        return href;
      } catch (err) {
        return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.query-correction {
  padding: $space-s $space-m;

  @include desktop {
    padding: $space-m;
  }
}

.query-correction__corrected,
.query-correction__override {
  @extend %ellipsis;
}

.query-correction__corrected {
  font-size: $font-l;
}

.query-correction__override {
  margin-top: $space-2s;
}
</style>
